export * from './ng2-c3-chart/ng2-c3-chart.directive';
